import { SVG, SVGProps } from './svg'

export function IconGift(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M19 8h-.5a4 4 0 00.5-2 3 3 0 00-3-3c-1.6.2-3 1-4 2.4A5.7 5.7 0 008 3a3 3 0 00-3 3c0 .7.2 1.4.5 2H5a2 2 0 00-2 2v3c0 .6.4 1 1 1h1v5c0 1.1.9 2 2 2h10a2 2 0 002-2v-5h1c.6 0 1-.4 1-1v-3a2 2 0 00-2-2zm-3-3c.6 0 1 .4 1 1a2 2 0 01-2 2h-2c0-1 2-3 3-3zM8 5a1 1 0 00-1 1c0 1.1.9 2 2 2h2c0-1-2-3-3-3zm3 5v2H5v-2h6zm0 9v-5H7v5h4zm2 0v-5h4v5h-4zm0-9v2h6v-2h-6z"
      />
    </SVG>
  )
}
